import { shallowMount } from "@vue/test-utils";
import OfertaCuenta from "@/views/OfertaEmprendedores";

describe("OfertaCuenta component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(OfertaCuenta);
  });

  it("Renders del component OfertaCuenta", () => {
    expect(wrapper).toBeDefined();
  });
});
